class PromoPopup {
  constructor(container) {
    this.container = container;
    this.popupModal = container.querySelector('.sign-up-popup-modal');
    this.overlay = container.querySelector('.sign-up-popup-overlay');
    this.closeButton = this.popupModal?.querySelector('.popup-modal__close');
    this.dismissButton = this.popupModal?.querySelector('.popup-modal__dismiss-btn');

    this.form = this.popupModal?.querySelector('.newsletter-form');
    this.formSucceeded = Boolean(this.form?.querySelector('[data-newsletter-success="true"]'));
    this.formHasErrors = Boolean(this.form?.querySelector('[data-newsletter-error="true"]'));

    this.successModal = container.querySelector('.success-popup-modal');
    this.successOverlay = container.querySelector('.success-popup-overlay');
    this.copyButton = this.successModal?.querySelector('.popup-modal__copy-btn');
    this.copySuccessMsg = this.successModal?.querySelector('.popup-modal__success-msg');
    this.successCloseButton = this.successModal?.querySelector('.popup-modal__close');
    this.successDismissButton = this.successModal?.querySelector('.popup-modal__dismiss-btn');

    this.sectionId = this.popupModal?.dataset.sectionId;
    this.testMode = this.popupModal?.dataset.testMode === 'true';
    this.delaySeconds = parseInt(this.popupModal?.dataset.delaySeconds || '0', 10);
    this.delayDays = parseInt(this.popupModal?.dataset.delayDays || '30', 10);
    this.displayTimer = this.popupModal?.dataset.displayTimer === 'true';
    this.timerDuration = parseFloat(this.popupModal?.dataset.timerDuration || '0') * 60;

    const queryParams = new URLSearchParams(window.location.search);
    this.previewMode =
      queryParams.has('preview_theme_id') ||
      queryParams.get('arca_popup_test') === '1' ||
      window.Shopify?.designMode === true;

    this.forceQaPopup = this.testMode;

    this.minutesElement = this.popupModal?.querySelector('.popup-modal__timer__minutes');
    this.secondsElement = this.popupModal?.querySelector('.popup-modal__timer__seconds');

    this.storageKey = `promo-popup-${window.location.host}-${this.sectionId}`;
    this.subscribedKey = `promo-bar-subscribed-${window.location.host}`;

    this.applyLocale();
    this.init();
  }

  applyLocale() {
    const discountCode = this.successModal?.querySelector(`#DiscountCode--${this.sectionId}`)?.value?.trim().toUpperCase();
    if (discountCode !== 'ARCA10') return;

    const locale = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    const translations = {
      de: {
        prefix: 'ARCA LUCIA',
        heading: 'Entdecke Designer-Pieces vor allen anderen!',
        text: 'Melde dich an und erhalte 10 % Willkommensvorteil auf deine erste Bestellung.',
        submit: 'Vorteil sichern',
        dismiss: 'Nein danke, weiter zur Boutique.',
        successPrefix: 'Dein Willkommensvorteil wartet auf dich',
        successHeading: 'Willkommen bei Arca Lucia',
        successText: 'Vielen Dank für deine Anmeldung. Verwende den folgenden Code bei deiner ersten Bestellung und sichere dir 10 % Willkommensvorteil.',
        discount: 'Dein Rabattcode:',
        copy: 'Code kopieren',
        copied: 'Code erfolgreich kopiert!',
        successDismiss: 'Jetzt Boutique entdecken',
        close: 'Schließen',
      },
      en: {
        prefix: 'ARCA LUCIA',
        heading: 'Discover new designer arrivals before anyone else.',
        text: 'Sign up and enjoy 10% off your first order.',
        submit: 'Unlock 10% off',
        dismiss: 'No thanks, continue to the boutique.',
        successPrefix: 'Your welcome offer is ready',
        successHeading: 'Welcome to Arca Lucia',
        successText: 'Thank you for signing up. Use the code below to enjoy 10% off your first order.',
        discount: 'Your discount code:',
        copy: 'Copy code',
        copied: 'Code copied successfully!',
        successDismiss: 'Explore the boutique',
        close: 'Close',
      },
      it: {
        prefix: 'ARCA LUCIA',
        heading: 'Scopri in anteprima i nuovi arrivi firmati!',
        text: 'Iscriviti e ricevi un vantaggio di benvenuto del 10% sul tuo primo ordine.',
        submit: 'Ottieni il vantaggio',
        dismiss: 'No grazie, continua nella boutique.',
        successPrefix: 'Il tuo vantaggio di benvenuto ti aspetta',
        successHeading: 'Benvenuti da Arca Lucia',
        successText: 'Grazie per l’iscrizione. Usa il seguente codice sul tuo primo ordine e ottieni un vantaggio di benvenuto del 10%.',
        discount: 'Il tuo codice sconto:',
        copy: 'Copia codice',
        copied: 'Codice copiato!',
        successDismiss: 'Scopri la boutique',
        close: 'Chiudi',
      },
    };

    const copy = translations[locale] || translations.de;
    const setText = (root, selector, value) => {
      const element = root?.querySelector(selector);
      if (element) element.textContent = value;
    };
    const setHtml = (root, selector, value, tagName = 'p') => {
      const element = root?.querySelector(selector);
      if (element) element.innerHTML = `<${tagName}>${value}</${tagName}>`;
    };

    setText(this.popupModal, '.popup-modal__title__prefix', copy.prefix);
    setText(this.popupModal, '.popup-modal__title .title', copy.heading);
    setHtml(this.popupModal, '.popup-modal__text', copy.text, 'h2');

    const submitButton = this.form?.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.textContent = copy.submit;
      submitButton.setAttribute('aria-label', copy.submit);
    }
    if (this.dismissButton) this.dismissButton.textContent = copy.dismiss;
    this.closeButton?.setAttribute('aria-label', copy.close);

    setText(this.successModal, '.popup-modal__title__prefix', copy.successPrefix);
    setText(this.successModal, '.popup-modal__title .title', copy.successHeading);
    setHtml(this.successModal, '.popup-modal__text', copy.successText);

    const discountInput = this.successModal?.querySelector(`#DiscountCode--${this.sectionId}`);
    const discountLabel = this.successModal?.querySelector(`label[for="DiscountCode--${this.sectionId}"]`);
    if (discountInput) discountInput.setAttribute('placeholder', copy.discount);
    if (discountLabel) discountLabel.textContent = copy.discount;

    if (this.copyButton) {
      const icon = this.copyButton.querySelector('svg');
      this.copyButton.textContent = copy.copy;
      if (icon) this.copyButton.appendChild(icon);
      this.copyButton.setAttribute('aria-label', copy.copy);
    }
    if (this.copySuccessMsg) this.copySuccessMsg.textContent = copy.copied;
    if (this.successDismissButton) this.successDismissButton.textContent = copy.successDismiss;
    this.successCloseButton?.setAttribute('aria-label', copy.close);
  }

  init() {
    if (!this.popupModal || !this.overlay) return;

    this.setupEventListeners();

    if (this.formSucceeded) {
      this.markSubscribed();
      this.showSuccessPopup();
      return;
    }

    if (this.formHasErrors) {
      this.showPopup();
      return;
    }

    if (this.forceQaPopup) {
      this.showPopup();
      return;
    }

    if (this.previewMode) {
      this.showPopup();
      return;
    }

    if (this.testMode) {
      this.showPopup();
      return;
    }

    this.checkAndShowPopup();
  }

  setupEventListeners() {
    this.closeButton?.addEventListener('click', () => this.closePopup());
    this.dismissButton?.addEventListener('click', () => this.closePopup());
    this.overlay?.addEventListener('click', () => this.closePopup());

    this.copyButton?.addEventListener('click', () => this.handleCopyCode());
    this.successCloseButton?.addEventListener('click', () => this.closeSuccessPopup());
    this.successDismissButton?.addEventListener('click', () => this.closeSuccessPopup());
    this.successOverlay?.addEventListener('click', () => this.closeSuccessPopup());
  }

  markSubscribed() {
    try {
      localStorage.setItem(this.subscribedKey, JSON.stringify({ subscribed: true }));
      localStorage.setItem(
        this.storageKey,
        JSON.stringify({
          next_display_date: this.calculateNextDisplayDate(),
          dismissed: false,
          subscribed: true,
        })
      );
    } catch (error) {
      console.warn('Promo popup storage unavailable:', error);
    }
  }

  isSubscribed() {
    try {
      const value = localStorage.getItem(this.subscribedKey);
      if (!value) return false;
      const parsed = JSON.parse(value);
      return parsed?.subscribed === true;
    } catch (error) {
      return false;
    }
  }

  calculateNextDisplayDate() {
    const now = new Date();
    return new Date(now.getTime() + this.delayDays * 24 * 60 * 60 * 1000).toISOString();
  }

  checkAndShowPopup() {
    if (this.isSubscribed()) return;

    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed?.subscribed) return;
        if (parsed?.next_display_date && new Date(parsed.next_display_date) > new Date()) return;
      }
    } catch (error) {
      console.warn('Promo popup storage unavailable:', error);
    }

    setTimeout(() => this.showPopup(), this.delaySeconds * 1000);
  }

  showPopup() {
    this.popupModal?.classList.add('popup-modal--active');
    this.overlay?.classList.add('popup-overlay--active');
    if (this.displayTimer) this.startTimer();
  }

  closePopup() {
    this.popupModal?.classList.remove('popup-modal--active');
    this.overlay?.classList.remove('popup-overlay--active');

    if (!this.forceQaPopup && !this.testMode && !this.previewMode && !this.isSubscribed()) {
      try {
        localStorage.setItem(
          this.storageKey,
          JSON.stringify({
            next_display_date: this.calculateNextDisplayDate(),
            dismissed: true,
          })
        );
      } catch (error) {
        console.warn('Promo popup storage unavailable:', error);
      }
    }
  }

  showSuccessPopup() {
    this.popupModal?.classList.remove('popup-modal--active');
    this.overlay?.classList.remove('popup-overlay--active');
    this.successModal?.classList.add('popup-modal--active');
    this.successOverlay?.classList.add('popup-overlay--active');
  }

  closeSuccessPopup() {
    this.successModal?.classList.remove('popup-modal--active');
    this.successOverlay?.classList.remove('popup-overlay--active');
  }

  async handleCopyCode() {
    const discountCode = this.successModal?.querySelector(`#DiscountCode--${this.sectionId}`);
    if (!discountCode) return;

    const text = discountCode.value;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        this.copyToClipboardFallback(text);
      }

      if (this.copySuccessMsg) {
        this.copySuccessMsg.style.display = 'block';
        setTimeout(() => {
          this.copySuccessMsg.style.display = 'none';
        }, 3000);
      }
    } catch (error) {
      this.copyToClipboardFallback(text);
    }
  }

  copyToClipboardFallback(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  startTimer() {
    if (!this.minutesElement || !this.secondsElement || !this.timerDuration) return;

    let timeLeft = Math.round(this.timerDuration);

    const updateTimer = () => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;

      this.minutesElement.textContent = minutes.toString().padStart(2, '0');
      this.secondsElement.textContent = seconds.toString().padStart(2, '0');

      if (timeLeft > 0) {
        timeLeft -= 1;
        setTimeout(updateTimer, 1000);
      } else {
        this.closePopup();
      }
    };

    updateTimer();
  }
}

function arcaTranslateProductOptionLabels() {
  const productRoot = document.querySelector('product-info[id^="MainProduct-"]');
  if (!productRoot) return;

  const locale = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
  const labels = {
    de: { size: 'Größe', color: 'Farbe' },
    en: { size: 'Size', color: 'Color' },
    it: { size: 'Taglia', color: 'Colore' },
  };
  const copy = labels[locale] || labels.de;

  productRoot.querySelectorAll('variant-selects .form__label').forEach((label) => {
    const text = (label.textContent || '').trim().toLowerCase();
    if (/^(size|größe|groesse|taglia)$/.test(text)) {
      label.textContent = copy.size;
      return;
    }
    if (/^(color|colour|farbe|colore)$/.test(text)) {
      label.textContent = copy.color;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="newsletter-popup"]');
  sections.forEach((section) => {
    const container = section.closest('section, .shopify-section');
    if (container) new PromoPopup(container);
  });
  arcaTranslateProductOptionLabels();
});

document.addEventListener('shopify:section:load', arcaTranslateProductOptionLabels);
